<template>
  <div class="comment_page">
    <Sticky>
      <NavBar title="评论详情" :border="false" left-arrow @click-left="onClickLeft"/>
    </Sticky>
    <div class="post_list comment">
      <div class="comment_list">
        <div class="item comment_content">
          <div class="avatar">
            <div class="avatar_img">
              <img :src="detail.avatar?toImPicUrlThum(detail.avatar):'/static/img/noavatar.gif'" alt="">
            </div>
            <img src="/static/img/female.png" alt="" class="user_sex" v-if="detail.sex == 0">
            <img src="/static/img/male.png" alt="" class="user_sex" v-if="detail.sex == 1">
          </div>
          <div class="user_b">
            <div class="user_t">
              <div class="user_n">
                <p>{{detail.userName}}</p>
                <span v-if="timeRule(detail.commentDate).o === 0">{{$t('detail.post.just')}}</span>
                <span v-if="timeRule(detail.commentDate).o === 1">{{$t('detail.post.someMinAgo',{num:timeRule(detail.commentDate).t})}}</span>
                <span v-if="timeRule(detail.commentDate).o === 2">{{$t('detail.post.someHourAgo',{num:timeRule(detail.commentDate).t})}}</span>
                <span v-if="timeRule(detail.commentDate).o === 3">{{$t('detail.post.dayAgo')}}</span>
                <span v-if="timeRule(detail.commentDate).o === 4">{{timeRule(detail.commentDate).t}}</span>
              </div>
              <div class="user_c">{{detail.thumbUpCount}} <Icon name="good-job-o" /> </div>
            </div>
            <div class="evaluation">
              <p class="content">{{detail.comments}}</p>
            </div>
          </div>
        </div>
        <p class="title">{{$t('detail.post.replyAll')}}({{detail.replyCount}})</p>
        <div class="item" v-for="(o,t) in detail.commentReplyVos" :key="o.id+t">
          <div class="avatar">
            <div class="avatar_img">
              <img :src="o.avatar?toImPicUrlThum(o.avatar):'/static/img/noavatar.gif'" alt="">
            </div>
            <img src="/static/img/female.png" alt="" class="sex" v-if="o.sex == 0">
            <img src="/static/img/male.png" alt="" class="sex" v-if="o.sex == 1">
          </div>
          <div class="user_b">
            <div class="user_t">
              <div class="user_n">
                <p>{{o.userName}}</p>
                <span v-if="timeRule(o.commentDate).o === 0">{{$t('detail.post.just')}}</span>
                <span v-if="timeRule(o.commentDate).o === 1">{{$t('detail.post.someMinAgo',{num:timeRule(o.commentDate).t})}}</span>
                <span v-if="timeRule(o.commentDate).o === 2">{{$t('detail.post.someHourAgo',{num:timeRule(o.commentDate).t})}}</span>
                <span v-if="timeRule(o.commentDate).o === 3">{{$t('detail.post.dayAgo')}}</span>
                <span v-if="timeRule(o.commentDate).o === 4">{{timeRule(o.commentDate).t}}</span>
              </div>
              <div class="user_c">{{o.thumbUpCount}} <Icon name="good-job-o" /> </div>
            </div>
            <div class="evaluation">
              <p class="content" v-if="o.pid == 1">{{o.comments}}</p>
              <p class="content" v-if="o.pid == 2"> <span>{{$t('detail.post.reply')}}</span> <span style="color:#00C8CA">{{o.replyuserName}}</span> {{o.comments}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../api/request'
import { toTime, toPicUrl, timeRule, toImPicUrlThum } from '../../utils/common'
  export default {
    name: '',
    data() {
      return {
        id: '',
        detail: {
          commentReplyVos: []
        }
      }
    },
    created () {
      this.id =  this.$route.params.id
      if (this.id) {
        this.getData()
      }
    },
    methods: {
      timeRule,
      toPicUrl,
      toImPicUrlThum,
      onClickLeft () {
        this.$router.go(-1)
      },
      getData () {
        request('get', 'app/interactive/queryCommentReply', {commentId: this.id}).then((res) => {
          if (res.code === 200) {
            // console.log(res)
            this.detail = {
              ...res.data,
              commentDate: res.data?toTime(res.data.commentDate): '--',
              commentReplyVos: res.data.commentReplyVos.map((o) => ({
                ...o,
                commentDate: o.commentDate?toTime(o.commentDate): '--'
              }))
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .comment{
    width: 325px;
    margin: 0 auto;
    
  }
</style>